import { motion } from 'framer-motion'
import { Box } from '@mui/material'
import type { ReactNode } from 'react'

interface PageTransitionProps {
  children: ReactNode
}

const variants = {
  initial: { opacity: 0, y: 12 },
  enter: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -8 },
}

export const PageTransition = ({ children }: PageTransitionProps) => (
  <Box
    component={motion.div}
    initial="initial"
    animate="enter"
    exit="exit"
    variants={variants}
    transition={{ duration: 0.25, ease: 'easeOut' }}
    sx={{ height: '100%' }}
  >
    {children}
  </Box>
)
